import { constants } from '@pdrj/pmi-iqos-shared-react'

const SPIN_TOOLTIP_DISPLAYED = 'SPIN_TOOLTIP_DISPLAYED#'
const SPINW_USER_SPUN = 'SPINW_USER_SPUN#'
const SPINW_UP_POPUP = 'SPINW_UP_POPUP#'

export default {
  ...constants,
  SPIN_TOOLTIP_DISPLAYED,
  SPINW_USER_SPUN,
  SPINW_UP_POPUP
}
